<template>
  <div id="orders">
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 订单列表卡片区 -->
    <el-card class="box-card">
      <!-- 查询表单 -->
      <el-form :inline="true" ref="form" :model="queryMap" label-width="90px">
        <el-form-item label="订单号">
          <el-input
            @keyup.enter.native="searchOrder"
            @clear="searchOrder"
            clearable
            v-model="queryMap.orderNo"
            placeholder="请输入订单号查询"
            style="width: 200px"
          ></el-input>
        </el-form-item>

        <el-form-item label="用户ID">
          <el-input
            @keyup.enter.native="searchOrder"
            @clear="searchOrder"
            clearable
            v-model="queryMap.userId"
            placeholder="请输入用户ID查询"
            style="width: 150px"
          ></el-input>
        </el-form-item>

        <el-form-item label="订单状态">
          <el-select
            v-model="queryMap.orderStatus"
            clearable
            @clear="searchOrder"
            placeholder="请选择订单状态"
            style="width: 180px"
          >
            <el-option label="待支付" value="0"></el-option>
            <el-option label="已支付" value="1"></el-option>
            <el-option label="已关闭" value="2"></el-option>
            <el-option label="已退款" value="3"></el-option>
            <el-option label="退款中" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
            v-model="queryMap.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="searchOrder"
          ></el-date-picker>
        </el-form-item>

        <el-form-item style="margin-left: 30px">
          <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button type="primary" @click="searchOrder" icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            @click="downExcel"
            v-hasPermission="'order:export'"
            icon="el-icon-download"
            >导出Excel</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="orderList"
        border
        style="width: 100%"
        height="600"
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column
          prop="orderNo"
          label="订单号"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          label="用户昵称"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="goodsTitle"
          label="商品标题"
          width="220"
        ></el-table-column>
        <el-table-column prop="goodsType" label="商品类型" width="100">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              type="info"
              v-if="scope.row.goodsType === '单招'"
              >单招</el-tag
            >
            <el-tag size="mini" type="primary" v-else>专升本</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="goodsCover" label="商品封面" width="100">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.goodsCover"
              :preview-src-list="[scope.row.goodsCover]"
              style="width: 40px; height: 40px; border-radius: 4px"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="payAmount"
          label="实际支付金额(元)"
          width="120"
          align="right"
        >
          <template slot-scope="scope">{{
            scope.row.payAmount.toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="订单状态" width="110">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              type="warning"
              v-if="scope.row.orderStatus === 0"
              >待支付</el-tag
            >
            <el-tag
              size="mini"
              type="success"
              v-else-if="scope.row.orderStatus === 1"
              >已支付</el-tag
            >
            <el-tag
              size="mini"
              type="danger"
              v-else-if="scope.row.orderStatus === 2"
              >已关闭</el-tag
            >
            <el-tag
              size="mini"
              type="info"
              v-else-if="scope.row.orderStatus === 3"
              >已退款</el-tag
            >
            <el-tag size="mini" type="primary" v-else>退款中</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="payTime"
          label="支付时间"
          width="180"
          sortable
        ></el-table-column>
        <el-table-column
          prop="closeTime"
          label="关闭时间"
          width="180"
          sortable
        ></el-table-column>
        <el-table-column
          prop="refundTime"
          label="退款时间"
          width="180"
          sortable
        ></el-table-column>
        <el-table-column prop="remark" label="订单备注" width="180">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.remark || '无备注'" placement="top">
              <span class="ellipsis">{{ scope.row.remark || "无备注" }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="创建时间"
          width="180"
          sortable
        ></el-table-column>
        <el-table-column
          prop="updatedAt"
          label="修改时间"
          width="180"
          sortable
        ></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryMap.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "OrderList",
  data() {
    return {
      loading: true,
      total: 0,
      orderList: [],
      // 查询参数（对应后端OrderQueryDTO）
      queryMap: {
        pageNum: 1,
        pageSize: 10,
        orderNo: "",
        userId: "",
        orderStatus: "",
        timeRange: [], // 时间范围：[startTime, endTime]
      },
    };
  },
  methods: {
    /**
     * 重置查询条件
     */
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 10,
        orderNo: "",
        userId: "",
        orderStatus: "",
        timeRange: [],
      };
      this.searchOrder();
    },

    /**
     * 搜索订单（整合查询条件）
     */
    searchOrder() {
      this.queryMap.pageNum = 1; // 重置为第一页
      this.getOrderList();
    },

    /**
     * 加载订单列表
     */
    async getOrderList() {
      this.loading = true;
      // 处理时间范围参数
      const params = { ...this.queryMap };
      if (this.queryMap.timeRange && this.queryMap.timeRange.length === 2) {
        params.startTime = this.queryMap.timeRange[0];
        params.endTime = this.queryMap.timeRange[1];
      }
      delete params.timeRange; // 删除原时间范围字段

      try {
        const { data: res } = await this.$http.get("order/findOrderList", {
          params,
        });
        if (res.code !== 200)
          return this.$message.error("获取订单列表失败：" + res.msg);
        console.log(res);
        this.total = res.data.total;
        this.orderList = res.data.rows;
      } catch (error) {
        this.$message.error("获取订单列表异常：" + error.message);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 导出Excel
     */
    downExcel() {
      const $this = this;
      // 构造导出参数（与查询条件一致）
      const params = { ...this.queryMap };
      if (this.queryMap.timeRange && this.queryMap.timeRange.length === 2) {
        params.startTime = this.queryMap.timeRange[0];
        params.endTime = this.queryMap.timeRange[1];
      }
      delete params.timeRange;

      axios
        .request({
          url: "/order/excel",
          method: "post",
          params, // 携带查询条件导出
          responseType: "blob",
        })
        .then((res) => {
          if (res.headers["content-type"] === "application/json") {
            // 权限不足或导出失败
            return res.data.then((data) => {
              $this.$message.error(data.msg || "导出失败，无权限或参数错误");
            });
          }
          // 下载文件
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `订单列表_${new Date().format("yyyyMMddHHmmss")}.xlsx`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          $this.$message.success("导出成功");
        })
        .catch((error) => {
          $this.$message.error("导出失败：" + error.message);
        });
    },

    /**
     * 每页条数改变
     */
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getOrderList();
    },

    /**
     * 页码改变
     */
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getOrderList();
    },
  },
  created() {
    // 页面加载时获取订单列表
    this.getOrderList();
  },
};
</script>

<style scoped>
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 100%;
}
.box-card {
  margin: 0 10px;
}
</style>
